import React from "react";

import img from "../../assets/images/new/label.webp";

function Counter(props) {
  return (
    <section className="couter">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="couter__main">
              <div className="couter-list">
                <div className="couter-box">
                  <div className="icon">
                    <svg
                      width="35"
                      height="31"
                      viewBox="0 0 35 31"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M17.5 12.1738C20.6907 12.1738 23.2773 9.58722 23.2773 6.39648C23.2773 3.20575 20.6907 0.619141 17.5 0.619141C14.3093 0.619141 11.7227 3.20575 11.7227 6.39648C11.7227 9.58722 14.3093 12.1738 17.5 12.1738Z"
                        fill="url(#paint0_linear_1065_853)"
                      />
                      <path
                        d="M29.1875 12.1738C31.2046 12.1738 32.8398 10.5386 32.8398 8.52148C32.8398 6.50435 31.2046 4.86914 29.1875 4.86914C27.1704 4.86914 25.5352 6.50435 25.5352 8.52148C25.5352 10.5386 27.1704 12.1738 29.1875 12.1738Z"
                        fill="url(#paint1_linear_1065_853)"
                      />
                      <path
                        d="M5.8125 12.1738C7.82963 12.1738 9.46484 10.5386 9.46484 8.52148C9.46484 6.50435 7.82963 4.86914 5.8125 4.86914C3.79537 4.86914 2.16016 6.50435 2.16016 8.52148C2.16016 10.5386 3.79537 12.1738 5.8125 12.1738Z"
                        fill="url(#paint2_linear_1065_853)"
                      />
                      <path
                        d="M9.41105 15.4536C7.97336 14.2757 6.67133 14.4316 5.00898 14.4316C2.52273 14.4316 0.5 16.4424 0.5 18.9134V26.1656C0.5 27.2387 1.3759 28.1113 2.45301 28.1113C7.10317 28.1113 6.54297 28.1955 6.54297 27.9108C6.54297 22.7719 5.93429 19.0032 9.41105 15.4536Z"
                        fill="url(#paint3_linear_1065_853)"
                      />
                      <path
                        d="M19.0806 14.4582C16.177 14.2161 13.6533 14.461 11.4764 16.2579C7.83357 19.1757 8.53462 23.1045 8.53462 27.9108C8.53462 29.1824 9.56923 30.2364 10.8602 30.2364C24.8773 30.2364 25.4352 30.6885 26.2664 28.8478C26.539 28.2253 26.4643 28.4231 26.4643 22.4682C26.4643 17.7383 22.3688 14.4582 19.0806 14.4582Z"
                        fill="url(#paint4_linear_1065_853)"
                      />
                      <path
                        d="M29.9919 14.4315C28.3205 14.4315 27.0256 14.2771 25.5898 15.4535C29.0406 18.9767 28.4579 22.4882 28.4579 27.9106C28.4579 28.1971 27.9929 28.1112 32.4782 28.1112C33.5938 28.1112 34.5009 27.2074 34.5009 26.0964V18.9132C34.5009 16.4423 32.4782 14.4315 29.9919 14.4315Z"
                        fill="url(#paint5_linear_1065_853)"
                      />
                      <defs>
                        <linearGradient
                          id="paint0_linear_1065_853"
                          x1="30.7502"
                          y1="-16.0273"
                          x2="4.99287"
                          y2="-13.4479"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop offset="0.164688" stopColor="#DEC7FF" />
                          <stop offset="0.855177" stopColor="#5C27FE" />
                        </linearGradient>
                        <linearGradient
                          id="paint1_linear_1065_853"
                          x1="37.5641"
                          y1="-5.65446"
                          x2="21.2807"
                          y2="-4.02384"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop offset="0.164688" stopColor="#DEC7FF" />
                          <stop offset="0.855177" stopColor="#5C27FE" />
                        </linearGradient>
                        <linearGradient
                          id="paint2_linear_1065_853"
                          x1="14.1891"
                          y1="-5.65446"
                          x2="-2.09431"
                          y2="-4.02384"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop offset="0.164688" stopColor="#DEC7FF" />
                          <stop offset="0.855177" stopColor="#5C27FE" />
                        </linearGradient>
                        <linearGradient
                          id="paint3_linear_1065_853"
                          x1="15.1742"
                          y1="-5.30959"
                          x2="-4.80447"
                          y2="-4.0081"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop offset="0.164688" stopColor="#DEC7FF" />
                          <stop offset="0.855177" stopColor="#5C27FE" />
                        </linearGradient>
                        <linearGradient
                          id="paint4_linear_1065_853"
                          x1="38.1106"
                          y1="-8.53467"
                          x2="-1.88821"
                          y2="-4.00346"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop offset="0.164688" stopColor="#DEC7FF" />
                          <stop offset="0.855177" stopColor="#5C27FE" />
                        </linearGradient>
                        <linearGradient
                          id="paint5_linear_1065_853"
                          x1="40.264"
                          y1="-5.31003"
                          x2="20.2854"
                          y2="-4.00857"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop offset="0.164688" stopColor="#DEC7FF" />
                          <stop offset="0.855177" stopColor="#5C27FE" />
                        </linearGradient>
                      </defs>
                    </svg>
                  </div>

                  <h6 className="numb">Scalability</h6>
                  <p style={{ fontSize: "12px" }}>Hnadling Millions of User</p>
                </div>
                <div className="couter-box">
                  <div className="icon">
                    <svg
                      width="34"
                      height="35"
                      viewBox="0 0 34 35"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0_1065_867)">
                        <path
                          d="M8.85351 25.31C6.58552 25.31 4.56812 23.8578 3.83556 21.696L3.78602 21.5331C3.61325 20.9605 3.54088 20.4791 3.54088 19.9974V10.3381L0.104009 21.8106C-0.338018 23.498 0.669255 25.2475 2.35928 25.7136L24.2658 31.5804C24.5393 31.6512 24.8127 31.6852 25.0819 31.6852C26.4928 31.6852 27.7821 30.7487 28.1434 29.3687L29.4197 25.31H8.85351Z"
                          fill="black"
                        />
                        <path
                          d="M8.85351 25.31C6.58552 25.31 4.56812 23.8578 3.83556 21.696L3.78602 21.5331C3.61325 20.9605 3.54088 20.4791 3.54088 19.9974V10.3381L0.104009 21.8106C-0.338018 23.498 0.669255 25.2475 2.35928 25.7136L24.2658 31.5804C24.5393 31.6512 24.8127 31.6852 25.0819 31.6852C26.4928 31.6852 27.7821 30.7487 28.1434 29.3687L29.4197 25.31H8.85351Z"
                          fill="url(#paint0_linear_1065_867)"
                        />
                        <path
                          d="M12.7515 10.4346C14.3141 10.4346 15.5847 9.16373 15.5847 7.60107C15.5847 6.03841 14.3141 4.76758 12.7515 4.76758C11.1888 4.76758 9.91797 6.03841 9.91797 7.60107C9.91797 9.16373 11.1888 10.4346 12.7515 10.4346Z"
                          fill="black"
                        />
                        <path
                          d="M12.7515 10.4346C14.3141 10.4346 15.5847 9.16373 15.5847 7.60107C15.5847 6.03841 14.3141 4.76758 12.7515 4.76758C11.1888 4.76758 9.91797 6.03841 9.91797 7.60107C9.91797 9.16373 11.1888 10.4346 12.7515 10.4346Z"
                          fill="url(#paint1_linear_1065_867)"
                        />
                        <path
                          d="M30.4562 0.517578H9.20573C7.2537 0.517578 5.66406 2.10722 5.66406 4.0595V19.643C5.66406 21.5953 7.2537 23.185 9.20573 23.185H30.4562C32.4085 23.185 33.9982 21.5953 33.9982 19.643V4.0595C33.9982 2.10722 32.4085 0.517578 30.4562 0.517578ZM9.20573 3.35107H30.4562C30.8474 3.35107 31.1647 3.66832 31.1647 4.0595V14.1167L26.6894 8.89457C26.2147 8.33788 25.5275 8.04035 24.7895 8.02348C24.0557 8.02764 23.3672 8.35345 22.8969 8.9174L17.6351 15.2329L15.921 13.5229C14.9521 12.554 13.3752 12.554 12.4076 13.5229L8.49755 17.4316V4.0595C8.49755 3.66832 8.8148 3.35107 9.20573 3.35107Z"
                          fill="black"
                        />
                        <path
                          d="M30.4562 0.517578H9.20573C7.2537 0.517578 5.66406 2.10722 5.66406 4.0595V19.643C5.66406 21.5953 7.2537 23.185 9.20573 23.185H30.4562C32.4085 23.185 33.9982 21.5953 33.9982 19.643V4.0595C33.9982 2.10722 32.4085 0.517578 30.4562 0.517578ZM9.20573 3.35107H30.4562C30.8474 3.35107 31.1647 3.66832 31.1647 4.0595V14.1167L26.6894 8.89457C26.2147 8.33788 25.5275 8.04035 24.7895 8.02348C24.0557 8.02764 23.3672 8.35345 22.8969 8.9174L17.6351 15.2329L15.921 13.5229C14.9521 12.554 13.3752 12.554 12.4076 13.5229L8.49755 17.4316V4.0595C8.49755 3.66832 8.8148 3.35107 9.20573 3.35107Z"
                          fill="url(#paint2_linear_1065_867)"
                        />
                      </g>
                      <defs>
                        <linearGradient
                          id="paint0_linear_1065_867"
                          x1="48.4466"
                          y1="-20.4157"
                          x2="-16.5545"
                          y2="-11.445"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop offset="0.164688" stopColor="#DEC7FF" />
                          <stop offset="0.855177" stopColor="#5C27FE" />
                        </linearGradient>
                        <linearGradient
                          id="paint1_linear_1065_867"
                          x1="19.2496"
                          y1="-3.39663"
                          x2="6.61749"
                          y2="-2.13171"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop offset="0.164688" stopColor="#DEC7FF" />
                          <stop offset="0.855177" stopColor="#5C27FE" />
                        </linearGradient>
                        <linearGradient
                          id="paint2_linear_1065_867"
                          x1="52.323"
                          y1="-32.1385"
                          x2="-10.4878"
                          y2="-24.2762"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop offset="0.164688" stopColor="#DEC7FF" />
                          <stop offset="0.855177" stopColor="#5C27FE" />
                        </linearGradient>
                        <clipPath id="clip0_1065_867">
                          <rect
                            width="34"
                            height="34"
                            fill="white"
                            transform="translate(0 0.452148)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>

                  <h6 className="numb">Big Data</h6>
                  <p style={{ fontSize: "12px" }}>
                    Managing large size of info
                  </p>
                </div>
                <div className="couter-box">
                  <div className="icon">
                    <svg
                      width="34"
                      height="35"
                      viewBox="0 0 34 35"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15.7711 4.90991C15.7711 3.80534 14.8711 2.89661 13.7752 3.035C6.00736 4.01597 0 10.6469 0 18.681C0 27.3911 7.06094 34.4521 15.7711 34.4521C23.8052 34.4521 30.4361 28.4447 31.4171 20.6769C31.5555 19.581 30.6467 18.681 29.5422 18.681H17.7711C16.6665 18.681 15.7711 17.7856 15.7711 16.681V4.90991Z"
                        fill="black"
                      />
                      <path
                        d="M15.7711 4.90991C15.7711 3.80534 14.8711 2.89661 13.7752 3.035C6.00736 4.01597 0 10.6469 0 18.681C0 27.3911 7.06094 34.4521 15.7711 34.4521C23.8052 34.4521 30.4361 28.4447 31.4171 20.6769C31.5555 19.581 30.6467 18.681 29.5422 18.681H17.7711C16.6665 18.681 15.7711 17.7856 15.7711 16.681V4.90991Z"
                        fill="url(#paint0_linear_1065_881)"
                      />
                      <path
                        d="M20.2224 0.577237C19.1266 0.438845 18.2266 1.34758 18.2266 2.45215V14.2232C18.2266 15.3278 19.122 16.2232 20.2266 16.2232H31.9976C33.1022 16.2232 34.011 15.3232 33.8726 14.2274C32.9741 7.11317 27.3366 1.47566 20.2224 0.577237Z"
                        fill="black"
                      />
                      <path
                        d="M20.2224 0.577237C19.1266 0.438845 18.2266 1.34758 18.2266 2.45215V14.2232C18.2266 15.3278 19.122 16.2232 20.2266 16.2232H31.9976C33.1022 16.2232 34.011 15.3232 33.8726 14.2274C32.9741 7.11317 27.3366 1.47566 20.2224 0.577237Z"
                        fill="url(#paint1_linear_1065_881)"
                      />
                      <defs>
                        <linearGradient
                          id="paint0_linear_1065_881"
                          x1="51.9417"
                          y1="-42.5317"
                          x2="-18.3711"
                          y2="-35.4906"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop offset="0.164688" stopColor="#DEC7FF" />
                          <stop offset="0.855177" stopColor="#5C27FE" />
                        </linearGradient>
                        <linearGradient
                          id="paint1_linear_1065_881"
                          x1="44.1974"
                          y1="-22.2687"
                          x2="9.04102"
                          y2="-18.7481"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop offset="0.164688" stopColor="#DEC7FF" />
                          <stop offset="0.855177" stopColor="#5C27FE" />
                        </linearGradient>
                      </defs>
                    </svg>
                  </div>

                  <h6 className="numb">Security</h6>
                  <p style={{ fontSize: "12px" }}>
                    Managing Complex systems securely
                  </p>
                </div>

                <div className="image">
                  <img src={img} alt="gensoft" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Counter;
